export const name = "recentlyViewedModule";

export const constants = { name };
